<template>
    <v-container fluid class="az-container configuracao-incisos-container" style="margin: 0 !important; border-radius: 10px !important;">
        <v-toolbar style="margin-top: 10px !important;" color="rgba(255, 255, 255, .5)" flat>
            <v-btn large dark color="primary" flat @click="onCriar" aria-label="Novo">
                <v-icon>add_circle_outline</v-icon>
                <span class="ml-2 font-weight-black text-capitalize">Novo</span>
            </v-btn>
        </v-toolbar>

        <v-layout class="pa-md-5 pa-3" row>
            <v-flex xs12>
                <v-card class="px-3 pt-3 pb-5 px-md-5" color="white">
                    <div class="mb-4">
                        <h3 class="primary--text mb-0">Configuração de Prazo para Incisos</h3>
                    </div>
                    <v-container fluid grid-list-sm style="max-height: 50vh; overflow-y: auto; background: white;">
                        <v-data-table
                            :headers="headers"
                            :items="itens"
                            :loading="carregando"
                            item-key="chave"
                            class="az-table-list"
                            no-results-text="Nenhum registro encontrado"
                            no-data-text="Nenhum registro"
                            hide-actions
                        >
                            <template slot="items" slot-scope="props">
                                <td>{{ props.item.amparo }}</td>
                                <td>{{ props.item.artigo }}</td>
                                <td>{{ props.item.inciso }}</td>
                                <td>{{ props.item.publicacao ? 'Sim' : 'Não' }}</td>
                                <td>{{ props.item.prazo }} dias</td>
                                <td>{{ props.item.diasMinimos ? 'Sim' : 'Não' }}</td>
                                <td class="text-xs-right">
                                    <v-tooltip top>
                                        <v-btn slot="activator" icon small class="mr-2" @click.stop="onEditar(props.item)">
                                            <v-icon color="#777777">edit</v-icon>
                                        </v-btn>
                                        <span>Editar</span>
                                    </v-tooltip>

                                    <v-tooltip top>
                                        <v-btn slot="activator" icon small @click.stop="onExcluir(props.item)">
                                            <v-icon color="#777777">delete</v-icon>
                                        </v-btn>
                                        <span>Excluir</span>
                                    </v-tooltip>
                                </td>
                            </template>

                            <template slot="progress">
                                <v-progress-linear indeterminate color="primary"/>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { actionTypes } from '@/core/constants'
import alertMixin from '@/views/mixins/alert'

export default {
    name: 'ConfiguracaoIncisos',
    mixins: [alertMixin],
    data: () => ({
        carregando: false,
        itens: [],
        headers: [
            { text: 'Amparo', value: 'amparo', class: 'primary--text font-weight-black', sortable: false },
            { text: 'Artigo', value: 'artigo', class: 'primary--text font-weight-black', sortable: false },
            { text: 'Inciso', value: 'inciso', class: 'primary--text font-weight-black', sortable: false },
            { text: 'Publicação', value: 'publicacao', class: 'primary--text font-weight-black', sortable: false },
            { text: 'Prazo', value: 'prazo', class: 'primary--text font-weight-black', sortable: false },
            { text: 'Dias Mínimos', value: 'diasMinimos', class: 'primary--text font-weight-black', sortable: false },
            { text: 'Ações', value: 'actions', class: 'primary--text font-weight-black text-xs-right', sortable: false }
        ]
    }),
    created() {
        this.buscarItens()
    },
    methods: {
        async buscarItens() {
            this.carregando = true
            try {
                const resposta = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_CONFIGURACAO_PRAZO_INCISOS)
                const itensNormalizados = Array.isArray(resposta) ? resposta : (resposta && resposta.items) ? resposta.items : []
                this.itens = itensNormalizados.map(i => ({
                    ...i,
                    chave: `${i.amparo || ''}|${i.artigo || ''}|${i.inciso || ''}`
                }))
            } catch (e) {
                this.itens = []
            } finally {
                this.carregando = false
            }
        },
        onCriar() {
            this.$emit('criar')
            if (this.$router && typeof this.$router.push === 'function') {
                this.$router.push({ name: 'ConfiguracaoIncisosCadastro' })
            }
        },
        onEditar(item) {
            this.$emit('editar', item)
            if (this.$router && typeof this.$router.push === 'function') {
                this.$router.push({ name: 'ConfiguracaoIncisosEdicao', params: { item } })
            }
        },
        async onExcluir(item) {
            try {
                const payload = { amparo: item.amparo, artigo: item.artigo, inciso: item.inciso }
                await this.$store.dispatch(actionTypes.COMPRADOR.REMOVER_CONFIGURACAO_PRAZO_INCISO, payload)
                this.mostrarNotificacaoSucessoDefault()
                await this.buscarItens()
            } catch (e) {
                this.mostrarNotificacaoErro(e.message)
            }
        }
    }
}
</script>

<style scoped>
.configuracao-incisos-container .v-data-table {
    font-size: 14px;
    position: relative;
}
</style>
